var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCalendarEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15538_22633",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15538_22633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 18.3346C3.70833 18.3346 3.31597 18.1714 2.98958 17.8451C2.66319 17.5187 2.5 17.1263 2.5 16.668V5.0013C2.5 4.54297 2.66319 4.15061 2.98958 3.82422C3.31597 3.49783 3.70833 3.33464 4.16667 3.33464H5V1.66797H6.66667V3.33464H13.3333V1.66797H15V3.33464H15.8333C16.2917 3.33464 16.684 3.49783 17.0104 3.82422C17.3368 4.15061 17.5 4.54297 17.5 5.0013V9.16797H15.8333V8.33464H4.16667V16.668H10V18.3346H4.16667ZM4.16667 6.66797H15.8333V5.0013H4.16667V6.66797ZM11.6667 18.3346V15.7721L16.2708 11.1888C16.3958 11.0638 16.5347 10.9735 16.6875 10.918C16.8403 10.8624 16.9931 10.8346 17.1458 10.8346C17.3125 10.8346 17.4722 10.8659 17.625 10.9284C17.7778 10.9909 17.9167 11.0846 18.0417 11.2096L18.8125 11.9805C18.9236 12.1055 19.0104 12.2444 19.0729 12.3971C19.1354 12.5499 19.1667 12.7027 19.1667 12.8555C19.1667 13.0082 19.1389 13.1645 19.0833 13.3242C19.0278 13.4839 18.9375 13.6263 18.8125 13.7513L14.2292 18.3346H11.6667ZM12.9167 17.0846H13.7083L16.2292 14.543L15.8542 14.1471L15.4583 13.7721L12.9167 16.293V17.0846ZM15.8542 14.1471L15.4583 13.7721L16.2292 14.543L15.8542 14.1471Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarEdit);
export default __webpack_public_path__ + "static/media/ic-calendar-edit.6ae26b915d96438e2c7e74c48cb8a35e.svg";
export { ForwardRef as ReactComponent };